import React from "react";
import { Asterisk } from "lucide-react";

const WORDS = [
  "TRANSITION EDITS",
  "SHIFT-PROOF BEAUTY",
  "HONEST WEAR-TESTS",
  "GRWM",
  "PR GIFTING",
  "BRAND AMBASSADOR",
];

export const Marquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y-[3px] border-clay-ink bg-clay-violet py-4 sm:py-5"
    >
      <div className="marquee-track items-center">
        {items.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="whitespace-nowrap px-6 font-display text-2xl font-black uppercase tracking-tight text-white sm:text-4xl">
              {w}
            </span>
            <Asterisk className="h-6 w-6 text-clay-lime sm:h-9 sm:w-9" strokeWidth={2.5} />
          </div>
        ))}
      </div>
    </div>
  );
};
